module.exports = __webpack_public_path__ + "img/image9.1323552b.png";